import { render, staticRenderFns } from "./BulkChangeArticleCalculations.vue?vue&type=template&id=5559c61c"
import script from "./BulkChangeArticleCalculations.vue?vue&type=script&lang=js"
export * from "./BulkChangeArticleCalculations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports